import { Link } from "react-router-dom";
import { ShoppingBasket } from "lucide-react";

const cutouts = (p) => (Array.isArray(p.cutout) ? p.cutout : [p.cutout || p.img]);

// Deterministic pseudo-random jitter so the layout is stable between renders
const jitter = (i, amp) => ((Math.sin(i * 12.9898) * 43758.5453) % 1) * amp;

// Basket interior (percent of the image box)
const AREA = { x0: 27, x1: 73, y0: 30, y1: 70 };

const layout = (n) => {
  const cols = Math.max(1, Math.ceil(Math.sqrt(n * 1.15)));
  const rows = Math.max(1, Math.ceil(n / cols));
  const w = (AREA.x1 - AREA.x0) / cols;
  const h = (AREA.y1 - AREA.y0) / rows;
  return Array.from({ length: n }, (_, i) => ({
    left: AREA.x0 + w * ((i % cols) + 0.5) + jitter(i + 1, w * 0.3),
    top: AREA.y0 + h * (Math.floor(i / cols) + 0.5) + jitter(i + 7, h * 0.3),
    rot: jitter(i + 3, 24) - 12,
    size: Math.max(34, Math.min(88, 180 / cols)),
  }));
};

export const CartBasket = ({ items }) => {
  const pieces = items.flatMap((i) =>
    Array.from({ length: i.quantity }, (_, k) => ({ key: i.lookup_key, name: i.product.name, k, imgs: cutouts(i.product) }))
  );
  const slots = layout(pieces.length);
  return (
    <div className="relative mx-auto w-full max-w-[420px] aspect-square select-none" data-testid="cart-basket">
      <img src="/illustrations/basket.jpg" alt="" className="absolute inset-0 w-full h-full object-contain mix-blend-multiply pointer-events-none" draggable={false} />
      {pieces.map((p, idx) => {
        const s = slots[idx];
        return (
          <Link
            key={`${p.key}-${p.k}`}
            to={`/produit/${p.key}`}
            title={p.name}
            className="absolute animate-drop-in hover:scale-110 hover:z-10 transition-transform flex items-end gap-0.5"
            style={{ left: `${s.left}%`, top: `${s.top}%`, "--rot": `${s.rot}deg`, animationDelay: `${Math.min(idx, 12) * 70}ms` }}
            data-testid={`basket-item-${p.key}-${p.k}`}
          >
            {p.imgs.map((src, j) => (
              <img key={src} src={src} alt={p.name} draggable={false}
                style={{ width: `${j === 0 ? s.size : s.size * 0.7}px` }}
                className="h-auto rounded-[3px] drop-shadow-[0_6px_10px_rgba(74,59,50,0.35)]" />
            ))}
          </Link>
        );
      })}
      {!pieces.length && (
        <div className="absolute inset-0 flex flex-col items-center justify-center text-[#4A3B32]/60">
          <ShoppingBasket className="w-8 h-8 mb-1" />
          <span className="font-cursive text-2xl">Panier vide</span>
        </div>
      )}
    </div>
  );
};
